import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { InstagramFeedPostSortField } from '@anytag/graphql';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsIgTaggedPostsSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema,
  sort: { field: InstagramFeedPostSortField }
});

export type AnalyticsIgTaggedPostsSearchSchemaType = z.infer<typeof AnalyticsIgTaggedPostsSearchSchema>;
